module.exports = __webpack_public_path__ + "static/icon_life_saving_gift_process_02@2x-d6489c34c5ad5759103a023bddd9f951.png";